import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import Switch from 'react-bootstrap-switch';
import _ from 'lodash';

import ViewConstants from 'constants/ViewConstants';

import SecurityContext from 'utils/permissions/SecurityContext';

// -- actions
import { RestaurantMenuAction, RouteAction } from 'actions';

// -- entities
import { RestaurantMenu, UpsellingCategory } from 'PMT/entities/menu';

// -- views
import SortableList from 'PMT/components/SortableList';
import EnabledDisabledIcon from 'PMT/components/EnabledDisabledIcon';

class UpsellingCategoryRow extends Component {

  static propTypes = {
    upsellingCategory: PropTypes.instanceOf(UpsellingCategory).isRequired,

    restaurantMenu: PropTypes.instanceOf(RestaurantMenu).isRequired,

    /**
     * @param UpsellingCategory
     */
    onToggleActivationUpsellingCategory: PropTypes.func.isRequired,

    /**
     * @param UpsellingCategory
     */
    onDeleteUpsellingCategory: PropTypes.func.isRequired,

    /**
     * @param UpsellingCategory
     */
    onMoveUpUpsellingCategory: PropTypes.func.isRequired,

    /**
     * @param UpsellingCategory
     */
    onMoveDownUpsellingCategory: PropTypes.func.isRequired,

  };

  static defaultProps = {
    hideDeactivatedProducts: true
  };

  shouldComponentUpdate(nextProps) {
    return !nextProps.upsellingCategory.equals(this.props.upsellingCategory)
    || !nextProps.restaurantMenu.equals(this.props.restaurantMenu);
  }

  onDeleteCategory = () => {
    this.props.onDeleteUpsellingCategory(this.props.upsellingCategory);
  };

  onUpCategory = () => {
    this.props.onMoveUpUpsellingCategory(this.props.upsellingCategory);
  };

  onDownCategory = () => {
    this.props.onMoveDownUpsellingCategory(this.props.upsellingCategory);
  };

  onDisplayDetail = () => {
    RouteAction.presentUpsellingCategoryDetail(this.props.upsellingCategory);
  };

  onToggleActivationCategory = () => {
    this.props.onToggleActivationUpsellingCategory(this.props.upsellingCategory);
  };

  //
  //
  //

  renderEnabled() {
    return (
      <Switch
        bsSize="mini"
        value={this.props.upsellingCategory.enabled}
        onChange={this.onToggleActivationCategory}
        disabled={!SecurityContext.restaurantMenu.canEdit()}
      />
    );
  }

  render(): Object {
    const upsellingCategory: UpsellingCategory = this.props.upsellingCategory;

    return (
      <div className="category_row pointer row">
        <div
          className="pointer col-xs-8 col-sm-4 category_row__name h100"
          onClick={this.onDisplayDetail}
        >
          {upsellingCategory.name}
        </div>

        <div
          className="pointer hidden-xs col-sm-4 category_row__description h100"
          onClick={this.onDisplayDetail}
        >
          {upsellingCategory.description}
        </div>

        <div className="hidden-xs col-sm-2">
          {this.renderEnabled()}
        </div>

        {SecurityContext.restaurantMenu.canEdit() &&
          <div
            className="pointer text-center col-xs-1 category_row__delete h100"
            onClick={this.onDeleteCategory}
          >
            <i className="fa fa-trash" />
          </div>
        }

        {SecurityContext.restaurantMenu.canEdit() &&
          <div
            className="pointer text-center col-xs-1 category_row__drag h100"
          >
            <SortableList.DragHandle />
          </div>
        }

      </div>
    );
  }

}

export default UpsellingCategoryRow;
